//@flow

import { Link } from "gatsby";
import React, { Fragment } from "react";

import SocialIcon from "@/components/SocialIcon/SocialIcon";

type Props = {
    links: SocialMedia[],
};

const FooterSocialIcons = ({links}: Props): React$Element<React$FragmentType> => {
    const icons = links.map(link => (
        <Link
            key={link.href}
            to={link.href}
            className="social-icon"
            target="_blank"
        >
            <div className="svg-box icon-xs">
                <div className="svg-container">
                    <SocialIcon icon={link.icon} />
                </div>
            </div>
        </Link>
    ));
    return <Fragment>{icons}</Fragment>;
};

export default FooterSocialIcons;
